import type { FC } from 'react'
import { SimpleTreeView } from '@mui/x-tree-view'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import groupBy from 'lodash/fp/groupBy'
import { Box, Typography } from '@mui/material'
import { WorklistSubCategory } from './WorklistTreeSubCategory'
import { WorklistsListResponse } from '@fireflyhealth/api'
import { sortedEntries } from '~/shared/lib/sortedEntries'
interface WorklistCategoryProps {
  categoryItems: WorklistsListResponse
  category: string
  expandingNodes: string[]
  setExpandingNodes: (nodeIds: string[]) => void
  selectWorklist: (worklistId: number) => void
  worklistId: number | undefined
}

export const WorklistCategory: FC<WorklistCategoryProps> = (props: WorklistCategoryProps) => {
  const subCategories = groupBy('sub_category', props.categoryItems)
  return (
    <div key={props.category}>
      <Box sx={{ ml: 2, mt: 2, color: 'grey.500' }}>
        <Typography variant="subtitle1" sx={{ textTransform: 'uppercase', fontWeight: 500 }}>
          {props.category}
        </Typography>
      </Box>
      {
        <SimpleTreeView
          sx={{ ml: '8px', mr: '16px' }}
          expandedItems={props.expandingNodes}
          onExpandedItemsChange={(event, nodes) => {
            props.setExpandingNodes(nodes)
          }}
          slots={{ expandIcon: ArrowRightIcon, collapseIcon: ArrowDropDownIcon }}
          slotProps={{ expandIcon: { fontSize: 'small' }, collapseIcon: { fontSize: 'small' } }}
        >
          {sortedEntries(subCategories).map(([subCategory, subCategoryItems]) => {
            return (
              <WorklistSubCategory
                key={subCategory}
                subCategoryItems={subCategoryItems}
                category={props.category}
                subCategory={subCategory}
                selectWorklist={props.selectWorklist}
                worklistId={props.worklistId}
              ></WorklistSubCategory>
            )
          })}
        </SimpleTreeView>
      }
    </div>
  )
}
